/**
 * @file Avatar image URL and initials from display name.
 */
import { getApiBase } from "./api";

/**
 * Full URL for the profile image, or undefined when none.
 */
export function resolveAvatarSrc(avatarUrl: string | null | undefined): string | undefined {
  if (!avatarUrl?.trim()) {
    return undefined;
  }
  const u = avatarUrl.trim();
  if (u.startsWith("http://") || u.startsWith("https://")) {
    return u;
  }
  const path = u.startsWith("/") ? u : `/${u}`;
  return `${getApiBase()}${path}`;
}

/**
 * - One word: first two characters
 * - Two words: first letter of each word
 * - Three or more words: first letter of first word + first letter of last word
 * - No name: first two characters of email
 */
export function displayNameInitials(name: string | null | undefined, email: string): string {
  const n = name?.trim();
  if (n) {
    const parts = n.split(/\s+/).filter(Boolean);
    if (parts.length === 1) {
      return parts[0]!.slice(0, 2).toUpperCase();
    }
    if (parts.length === 2) {
      return (parts[0]![0]! + parts[1]![0]!).toUpperCase();
    }
    return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
  }
  return email.slice(0, 2).toUpperCase();
}
